import React from "react";
import Form from "react-bootstrap/Form";
import FieldLabel from "components/form/label/FieldLabel";

const FormFieldGroup = ({
    controlId,
    label,
    type = "text",
    placeholder,
    className = "",
    readOnly = false,
    register,
    name,
    error,
}) => (
    <Form.Group className="mb-3" controlId={controlId}>
        <FieldLabel label={label} />
        <Form.Control
            type={type}
            placeholder={placeholder}
            className={className}
            readOnly={readOnly}
            {...register(name)}
        />
        {error && <p className="text-danger">{error.message}</p>}
    </Form.Group>
);

export default FormFieldGroup;